import { useState } from "react";
//---------------------------------------------------------------------
import Modal from "src/components/common/modal";
import {
    arrayReducer, numberReducer
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function DataTableForm({
    keyword, closeIt,
    rawData
}){
    const [curWorkOut, setCurWorkOut] = useState("");
    const [unit, setUnit] = useState("");
    const settings = rawData.settings || [];
    const curData = {...rawData};
    const mode = curWorkOut?settings.find(setting => setting.hashKey === curWorkOut).mode:"";
    delete curData.settings;
    const imutableWorkOuts = {};
    let maxColumnNumber = 0;
    Object.entries(curData).forEach(([key, value]) => {
        if(value.every(date => curWorkOut !== date.hashKey)) return;
        imutableWorkOuts[key] = value.filter(date => curWorkOut === date.hashKey).map(date => date.sets).reduce(arrayReducer, []);
        maxColumnNumber = Math.max(imutableWorkOuts[key].length, maxColumnNumber);
    })
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"900px"}
            maxWidth = {"100%"}
        >
            <div className = "my-3">
                <span className = "blk">
                    <span className = "mr-3">Work Out Name</span>
                    <select className = "inline form-control mr-3" value = {curWorkOut} onChange = {e => {
                        setCurWorkOut(e.currentTarget.value);
                        const mode = e.currentTarget.value?settings.find(setting => setting.hashKey === e.currentTarget.value).mode:"";
                        if(mode === "Repetition"){
                            setUnit("LBS");
                        }else{
                            setUnit("Mixed");
                        }
                    }}>
                        <option value = "">Select</option>
                        {settings.map((setting, settingIndex) => <option key = {settingIndex} value = {setting.hashKey}>{setting.name}</option>)}
                    </select>
                </span>
                <span className = "mr-3">Total Volume Unit</span>
                {mode === "Repetition"?
                <select required className = "inline form-control" value = {unit} onChange = {e => {
                    setUnit(e.currentTarget.value);
                }}>
                    <option>LBS</option>
                    <option>KGS</option>
                </select>
                :
                <select required className = "inline form-control" value = {unit} onChange = {e => {
                    setUnit(e.currentTarget.value);
                }}>
                    <option>Mixed</option>
                    <option>Hours</option>
                    <option>Minutes</option>
                    <option>Seconds</option>
                </select>
                }
            </div>
            <div className = "table-responsive" style = {{overflow: "visible"}}>
                {curWorkOut?<table className = "table" style = {{position: "relative"}}>
                    <thead>
                        <tr>
                            <th>Dates \ Sets</th>
                            {Array.from({length: maxColumnNumber}).map((value, key) => <th key = {key}>Set {key + 1}</th>)}
                            <th>Total Volume</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(imutableWorkOuts).map(date => <tr key = {date}>
                            <th>{date}</th>
                            {imutableWorkOuts[date].map((set, setIndex) => 
                            mode === "Repetition"?
                            <td key = {setIndex}>{set.weight}{set.unit} x {set.reps}</td>
                            :
                            <td key = {setIndex}>{set.hours === "0"?"":`${set.hours} hrs  `}{set.minutes === "0"?"":`${set.minutes} mins  `}{set.seconds === "0"?"":`${set.seconds} secs`}</td>
                            )}
                            {Array.from({length: maxColumnNumber - imutableWorkOuts[date].length}).map((dummy, dummyIndex) => <td key = {dummyIndex}></td>)}
                            {mode === "Repetition"?
                            <td>{(imutableWorkOuts[date].map(set => set.weight * set.reps * (set.unit === "KGS"?2.2:1)).reduce(numberReducer, 0) / (unit === "KGS"?2.2:1)).toFixed(2)} {unit}</td>
                            :
                            <td>
                                {unit === "Hours"?<>{imutableWorkOuts[date].map(set => (window.Number.parseFloat(set.hours) + window.Number.parseFloat(set.minutes) / 60 + window.Number.parseFloat(set.seconds) / 60 / 60)).reduce(numberReducer, 0).toFixed(2)} hrs</>:null}
                                {unit === "Minutes"?<>{imutableWorkOuts[date].map(set => (window.Number.parseFloat(set.hours) * 60 + window.Number.parseFloat(set.minutes) + window.Number.parseFloat(set.seconds) / 60)).reduce(numberReducer, 0).toFixed(2)} mins</>:null}
                                {unit === "Seconds"?<>{imutableWorkOuts[date].map(set => (window.Number.parseFloat(set.hours) * 60 * 60 + window.Number.parseFloat(set.minutes) * 60 + window.Number.parseFloat(set.seconds))).reduce(numberReducer, 0)} secs</>:null}
                                {unit === "Mixed"?<>
                                {Math.floor(imutableWorkOuts[date].map(set => (window.Number.parseFloat(set.hours) * 60 * 60 + window.Number.parseFloat(set.minutes) * 60 + window.Number.parseFloat(set.seconds))).reduce(numberReducer, 0) / 3600)} hrs &nbsp;
                                {Math.floor(imutableWorkOuts[date].map(set => (window.Number.parseFloat(set.hours) * 60 * 60 + window.Number.parseFloat(set.minutes) * 60 + window.Number.parseFloat(set.seconds))).reduce(numberReducer, 0) % 3600 / 60)} mins &nbsp; 
                                {imutableWorkOuts[date].map(set => (window.Number.parseFloat(set.hours) * 60 * 60 + window.Number.parseFloat(set.minutes) * 60 + window.Number.parseFloat(set.seconds))).reduce(numberReducer, 0) % 60} secs
                                </>:null}
                            </td>
                            }
                        </tr>)}
                    </tbody>
                </table>:null}
            </div>
        </Modal>
    )
}